import { render, staticRenderFns } from "./TermoUsoModelo.vue?vue&type=template&id=1dbe2f2e&"
import script from "./TermoUsoModelo.vue?vue&type=script&lang=js&"
export * from "./TermoUsoModelo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports